// components/StepIndicator.jsx

const StepIndicator = ({ step = 1, totalSteps = 4, header = "Step Header" }) => {
    const percent = (step / totalSteps) * 100;

    return (
        <div className="px-4 mb-3">
            <p className="text-xs text-center font-semibold text-[#404040]">
                Step {step} of {totalSteps}
            </p>
            <p
                className="text-lg text-center pt-1 pb-2 font-semibold"
                style={{ color: "var(--partner-primary)" }}
            >
                {header}
            </p>
            <div className="w-full h-2 mt-1  bg-gray-200 rounded-full">
                <div
                    className="h-full rounded-full transition-all duration-300"
                    style={{ backgroundColor: "var(--partner-primary)", width: `${percent}%` }}
                   
                ></div>
            </div>
        </div >
    );
};

export default StepIndicator;
